import styled, { css } from 'styled-components';

import colors from '@utils/colors';
import { mq } from '@utils/responsive';
import { H_PADDING_MOBILE } from '@utils/space';
import { Heading as UnstyledHeading } from '@components/type';
import UnstyledImage from 'gatsby-image';
import { CTA } from '../../type';

export const Cards = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  margin-right: 30px;
  ${mq.gtsm`
  `}
  ${mq.gtms`
    flex-direction: row;
        align-items: center;
  `}
`;

export const Card = styled.div`
  gap: 16px;
  position: relative;
  width: 50vw;
  max-width: 350px;
  &:nth-child(2) {
    width: 60vw;
    max-width: 500px;
    align-self: flex-end;
    top: -10px
  }
  &:nth-child(3) {
    width: 45vw;
    max-width: 300px;
    top: -25px;
  }
  ${mq.gtms`
    width: 30vw;
      &:nth-child(2) {
        width: 40vw;
        translate: 0 200px;
        top: 0;
      }
      &:nth-child(3) {
        width: 25vw;
        top: 0;
      }
    `}
`;

export const CardData = styled.div`
  padding-top: 24px;
`;

export const CardTitle = styled(UnstyledHeading)`
  color: ${colors.B500};
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  ${mq.gtms`
     font-size: 40px;
   `}
`;

export const Link = styled(CTA)`
  text-transform: uppercase;
  display: block;
  text-align: center;
  color: ${colors.B500};
  text-decoration: underline;
  font-size: 20px;
`;

export const Image = styled(UnstyledImage)`
  position: absolute;
  overflow: hidden;
  border-radius: 50%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  width: 100%;
  aspect-ratio: 1 / 1;

  img {
    filter: brightness(80%) contrast(80%);
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  ${mq.gtsm`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0 ${H_PADDING_MOBILE};
  `}
`;

export const Inner = styled.div`
  position: relative;
  z-index: 1;
  padding: 18px ${H_PADDING_MOBILE};
  ${mq.gtmd`
    display: flex;
    padding: 0 calc((100vw - 1280px) / 2);
  `}
  & > svg {
    position: absolute;
    top: 20%;
    right: 0;
    left: 0;
    width: 100%;
    z-index: 0;
    stroke: ${colors.Y500};
    ${mq.gtsm`
      top: ${props => props.flipped ? 'auto' : '0'};
      bottom: ${props => props.flipped ? '0' : 'auto'};
    `}
  }
`;

export const Wrapper = styled.div`
  ${mq.gtms`
      padding-bottom: 300px;
    `}
  & > svg {
    z-index: 0;
  }
  & > svg:first-of-type {
    fill: ${(props) =>
  props.outline && props.outline !== 'none' ? 'none' : getThemeStyles(props.colorTheme).background};
    stroke: ${(props) =>
  props.outline === 'top' || props.outline === 'both'
    ? getThemeStyles(props.colorTheme).outline
    : 'none'};
    stroke-width: ${(props) =>
  props.outline === 'top' || props.outline === 'both' ? '3px' : 0};
    vertical-align: bottom;
    ${mq.gtsm`
      stroke-width: 1px;
    `}
    ${(props) =>
  props.outline && props.outline !== 'none' &&
  css`
        width: calc(100% + 6px);
        margin-right: -3px;
        margin-bottom: -3px;
        margin-left: -3px;
      `}
  }
  & > svg:last-of-type {
    fill: ${(props) =>
  props.outline && props.outline !== 'none' ? 'none' : getThemeStyles(props.colorTheme).background};
    stroke: ${(props) =>
  props.outline === 'bottom' || props.outline === 'both'
    ? getThemeStyles(props.colorTheme).outline
    : 'none'};
    stroke-width: ${(props) =>
  props.outline === 'bottom' || props.outline === 'both' ? '3px' : 0};
    transform: scale(-1, -1) translateY(1px);
    vertical-align: top;
    ${mq.gtsm`
      stroke-width: 1px;
    `}
    ${(props) =>
  props.outline &&
  css`
        width: calc(100% + 6px);
        margin-right: -3px;
        margin-top: -1px;
        margin-left: -3px;
      `}
  }
`;

export function getThemeStyles(theme) {
  switch (theme) {
    case 'white':
      return {
        outline: colors.B500,
        background: '#fff',
        swirl: colors.B100,
        fill: colors.B200,
        text: colors.B500,
      };
    case 'dark-blue':
      return {
        outline: colors.B500,
        background: colors.B500,
        fill: colors.B200,
        text: '#fff',
      };
    case 'dark-purple':
      return {
        outline: colors.P500,
        background: colors.P500,
        fill: colors.P200,
        text: '#fff',
      };
    case 'green':
      return {
        outline: colors.G100,
        background: colors.G100,
        fill: colors.G200,
        text: colors.G500,
      };
    case 'orange':
      return {
        outline: colors.O100,
        background: colors.O100,
        fill: colors.O200,
        text: colors.O500,
      };
    default:
      return {
        outline: colors.Y100,
        background: colors.Y100,
        fill: colors.Y200,
        text: colors.B500,
      };
  }
}
